<div class="gridContainer">
	<!--FORM-->
	<sim-labelled-container label="CREATE_SESSION_DIALOG_CREATE_SESSION" icon="fa-cube">
		<!--TITLE-->
		<mat-form-field class="full-width-form" color="accent">
			<mat-label>
				<mat-icon fontIcon="fa-signature" fontSet="fad" />
				{{ T.CREATE_SESSION_DAILOG_SESSION_NAME | translate }}
			</mat-label>
			<input [formControl]="step1Form.controls.title" matInput />
			<mat-error>
				{{ T.CREATE_SESSION_DIALOG_ERROR_MESSAGE | translate }}
			</mat-error>
		</mat-form-field>

		<!--DATE-->
		<mat-form-field class="full-width-form" color="accent">
			<mat-label>
				<mat-icon fontIcon="fa-calendar-week" fontSet="fad" />
				{{ T.LABEL_DATE | translate }}
			</mat-label>
			<input
				(click)="datepicker.open()"
				[formControl]="step1Form.controls.date"
				[matDatepicker]="datepicker"
				[max]="eventEndDate"
				[min]="eventStartDate"
				matInput
				readonly
			/>
			@if (step1Form.controls.date.hasError("required")) {
				<mat-error>{{ T.ERROR_INVALID | translate: {item: T.LABEL_DATE | translate} }} </mat-error>
			}
			<mat-datepicker-toggle [for]="datepicker" matIconSuffix>
				<mat-icon color="accent" fontIcon="fa-calendar-day" fontSet="fa" matDatepickerToggleIcon />
			</mat-datepicker-toggle>
			<mat-datepicker #datepicker />
		</mat-form-field>

		<!--TRAINING-->
		<sim-autocomplete
			(onSelect)="addRoom($any($event), 'training')"
			[dataType]="FetchDataType.TrainingRoom"
			[excludeIds]="typedExcludeRoomIds().get('training').concat(typedExcludeRoomIds().get('liveStream'))"
			[labelToken]="T.CREATE_SESSION_DIALOG_TRAINING_ROOM_LABEL"
			subscriptSizing="fixed"
		>
			<ng-container labelPrefix>
				<mat-icon fontIcon="fa-door-open" fontSet="fad" />
			</ng-container>
			<ng-container actions>
				<button (click)="openRoomDetailDialog('training')" color="accent" mat-icon-button>
					<mat-icon fontIcon="fa-th" fontSet="fad" />
				</button>
			</ng-container>
		</sim-autocomplete>

		<!--DEBRIEFING-->
		<sim-autocomplete
			(onSelect)="addRoom($any($event), 'debriefing')"
			[dataType]="FetchDataType.TrainingRoom"
			[excludeIds]="typedExcludeRoomIds().get('debriefing')"
			[labelToken]="T.CREATE_SESSION_DIALOG_DEBRIEFING_ROOM_LABEL"
			subscriptSizing="fixed"
		>
			<ng-container labelPrefix>
				<mat-icon fontIcon="fa-door-open" fontSet="fad" />
			</ng-container>

			<ng-container actions>
				<button (click)="openRoomDetailDialog('debriefing')" color="accent" mat-icon-button>
					<mat-icon fontIcon="fa-th" fontSet="fad" />
				</button>
			</ng-container>
		</sim-autocomplete>

		<!--LIVESTREAM-->
		<sim-autocomplete
			(onSelect)="addRoom($any($event), 'liveStream')"
			[dataType]="FetchDataType.TrainingRoom"
			[excludeIds]="typedExcludeRoomIds().get('liveStream').concat(typedExcludeRoomIds().get('training'))"
			[labelToken]="T.CREATE_SESSION_DIALOG_LIVESTREAM_ROOM_LABEL"
			subscriptSizing="dynamic"
		>
			<ng-container labelPrefix>
				<mat-icon fontIcon="fa-door-open" fontSet="fad" />
			</ng-container>

			<ng-container actions>
				<button (click)="openRoomDetailDialog('liveStream')" color="accent" mat-icon-button>
					<mat-icon fontIcon="fa-th" fontSet="fad" />
				</button>
			</ng-container>
		</sim-autocomplete>
	</sim-labelled-container>

	<!--LIST-->
	<sim-list class="roomList" icon="fa-door-open" [label]="T.TEAM_TRAINING_SESSION_DIALOG_STEP1_ROOM_LIST" [counter]="roomCount()">
		<!--SUBLIST: TRAINING-->
		<div class="subList">
			@if (displayRooms().get("training")?.length) {
				<label class="secondary"> {{ T.TEAM_TRAINING_SESSION_DIALOG_STEP1_TRAINING_ROOMS | translate }} </label>
				@for (room of displayRooms().get("training"); track room.id) {
					<sim-list-item
						[primaryLabel]="room.name"
						[secondaryLabel]="room.roomCapabilities | getRoomCapabilityString"
						[indicator]="{fontIcon: 'fa-door-open', fontSet: 'fa'}"
						[selectable]="false"
					>
						<ng-container actions>
							<button mat-icon-button color="warn" (click)="removeRoom(room, 'training')">
								<mat-icon fontIcon="fa-times" fontSet="fa" />
							</button>
						</ng-container>
					</sim-list-item>
				}
			} @else {
				<div class="emptyState secondary">
					<mat-icon fontSet="fad" fontIcon="fa-door-open" />
					{{ T.TEAM_TRAINING_SESSION_DIALOG_STEP1_TRAINING_ROOM_REQUIRED | translate }}
				</div>
			}
		</div>

		<!--SUBLIST: DEBRIEFING-->
		@if (displayRooms().get("debriefing")?.length) {
			<mat-divider />
			<div class="subList">
				<label class="secondary"> {{ T.TEAM_TRAINING_SESSION_DIALOG_STEP1_DEBRIEFING_ROOMS | translate }} </label>
				@for (room of displayRooms().get("debriefing"); track room.id) {
					<sim-list-item
						[primaryLabel]="room.name"
						[secondaryLabel]="room.roomCapabilities | getRoomCapabilityString"
						[indicator]="{fontIcon: 'fa-users-class', fontSet: 'fa'}"
						[selectable]="false"
					>
						<ng-container actions>
							<button mat-icon-button color="warn" (click)="removeRoom(room, 'debriefing')">
								<mat-icon fontIcon="fa-times" fontSet="fa" />
							</button>
						</ng-container>
					</sim-list-item>
				}
			</div>
		}

		<!--SUBLIST: LIVESTREAM-->
		@if (displayRooms().get("liveStream")?.length) {
			<mat-divider />
			<div class="subList">
				<label class="secondary"> {{ T.TEAM_TRAINING_SESSION_DIALOG_STEP1_LIVESTREAMING_ROOMS | translate }} </label>
				@for (room of displayRooms().get("liveStream"); track room.id) {
					<sim-list-item
						[primaryLabel]="room.name"
						[secondaryLabel]="room.roomCapabilities | getRoomCapabilityString"
						[indicator]="{fontIcon: 'fa-chromecast', fontSet: 'fab'}"
						[selectable]="false"
					>
						<ng-container actions>
							<button mat-icon-button color="warn" (click)="removeRoom(room, 'liveStream')">
								<mat-icon fontIcon="fa-times" fontSet="fa" />
							</button>
						</ng-container>
					</sim-list-item>
				}
			</div>
		}
		@if (roomCount() > 0) {
			<mat-divider />
		}
	</sim-list>
</div>
